namespace GeniuzPOS.Purchase {
    export interface PoPo06DtPendingCNforCnrtvForm {
    }

    export class PoPo06DtPendingCNforCnrtvForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPo06DtPendingCNforCnrtv';
    }
}
